import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, subDays } from "date-fns";
import "./AppDatePicker.css";

interface RangeDatePickerProps {
  onChange: (dates: [Date | null, Date | null]) => void;
  minDaysSub: number;
  maxDaysAdd: number;
  defaultStartDate?: number; // Optional or nullable
  defaultEndDate?: number ;   // Optional or nullable
}

const RangeDatePicker: React.FC<RangeDatePickerProps> = ({
  onChange,
  minDaysSub,
  maxDaysAdd,
  defaultStartDate,
  defaultEndDate,
}) => {
  const [startDate, setStartDate] = useState<Date | undefined>(
    defaultStartDate !== undefined ? subDays(new Date(), defaultStartDate) : undefined
  );
  const [endDate, setEndDate] = useState<Date | undefined>(
    defaultEndDate !== undefined ? addDays(new Date(), defaultEndDate) : undefined
  );

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0] ?? undefined);
    setEndDate(dates[1] ?? undefined);
    onChange(dates);
  };

  return (
    <DatePicker
      selectsRange
      dateFormat="dd/MM/yyyy"
      startDate={startDate}
      endDate={endDate}
      onChange={handleDateChange}
      isClearable
      minDate={subDays(new Date(), minDaysSub)}
      maxDate={addDays(new Date(), maxDaysAdd)}
      locale="en-GB"
      className="mr-1 px-4 py-1 border rounded pr-6"
    />
  );
};

export default RangeDatePicker;
